import script from "./index.vue?vue&type=script&setup=true&name=component-lpb&lang=js"
export * from "./index.vue?vue&type=script&setup=true&name=component-lpb&lang=js"

import "./index.vue?vue&type=style&index=0&id=6ac1b654&lang=scss"

const __exports__ = script;

export default __exports__